import {HeadCell} from "interfaces";

export const headCells: readonly HeadCell[] = [
  {
    id: "name",
    disablePadding: true,
    label: "Nombre",
  },
  {
    id: "idCard",
    disablePadding: false,
    label: "CI",
  },
  {
    id: "email",
    disablePadding: false,
    label: "Correo",
  },
  {
    id: "phone",
    disablePadding: false,
    label: "Teléfono",
  },
  {
    id: "action",
    disablePadding: false,
    label: "",
  },
];
